<template>
  <div id="app">
<template>
    <b-navbar>
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <img src="https://static.wixstatic.com/media/994a83_47ab565b7b0d408491c54371b8aa0b3b~mv2.png/v1/crop/x_0,y_1,w_291,h_62/fill/w_296,h_63,al_c,lg_1,q_80/1_Primary_logo_on_transparent_306x63.webp" alt="声劇ユニット たいぷぼいすっ">
            </b-navbar-item>
        </template>
        <template slot="start">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                Home
            </b-navbar-item>
            <b-navbar-item tag="router-link" to="member">
                Member
            </b-navbar-item>
            <b-navbar-dropdown label="Playlist">
                <b-navbar-item href="#">
                    About
                </b-navbar-item>
                <b-navbar-item href="#">
                    Contact
                </b-navbar-item>
            </b-navbar-dropdown>
        </template>
    </b-navbar>
</template>
    <section>
      <router-view></router-view>
    </section>
        <footer class="footer">
  <div class="content has-text-centered">
    <p>
      <strong>TypeVoice Official Site.</strong> by <a href="https://e10ulen.hatenablog.com/">SEN@</a>
    </p>
  </div>
</footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #8c67ef;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

$box-background-color: #282c37;
$box-color: #f2f5f9;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy"
</style>



// WEBPACK FOOTER //
// src/App.vue